export const PLANS = {
  core: {
    name: 'Tracksy Core',
    price: 6.99,
    yearlyPrice: 69.90,
    aiMessagesPerMonth: 50,
    voiceMemoLimit: 10,
    voiceMemoMaxSeconds: 120,
    voiceMemoDownload: false,
    voiceMemoTranscription: false,
    voiceMemoPurgeDays: null,
    salesHistoryMonths: 2,
    exportPDF: true,
    exportExcel: false,
    insightsReport: false,
    winRate: false,
    performanceTrend: false,
  },
  pro: {
    name: 'Tracksy Pro',
    price: 9.99,
    yearlyPrice: 99.90,
    aiMessagesPerMonth: 200,
    voiceMemoLimit: 25,
    voiceMemoMaxSeconds: null,
    voiceMemoDownload: true,
    voiceMemoTranscription: true,
    voiceMemoPurgeDays: 30,
    salesHistoryMonths: null,
    exportPDF: true,
    exportExcel: true,
    insightsReport: true,
    winRate: true,
    performanceTrend: true,
  },
  team: {
    name: 'Tracksy Team',
    comingSoon: true,
  },
};
